import React from "react";

function IsLoading() {
  return (
    <div id="loading-div">
      <img id="loading-img" alt = '' src="/Assests/Images/loading.gif" />
      <h2 id="loading">Loading...</h2>
    </div>
  );
}

export default IsLoading;
